import { render, staticRenderFns } from "./WorkspaceInvite.vue?vue&type=template&id=3f9a9854&scoped=true"
import script from "./WorkspaceInvite.vue?vue&type=script&lang=ts"
export * from "./WorkspaceInvite.vue?vue&type=script&lang=ts"
import style0 from "./WorkspaceInvite.vue?vue&type=style&index=0&id=3f9a9854&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9a9854",
  null
  
)

export default component.exports